import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { CheckinPage } from '@/components/checkin-page'

const checkinSearchSchema = z.object({
  checkinId: z.string().optional(),
})

export const Route = createFileRoute('/_liff/checkin')({
  validateSearch: (search) => checkinSearchSchema.parse(search),
  component: CheckinRoute,
})

function CheckinRoute() {
  const { checkinId } = Route.useSearch()
  return <CheckinPage checkinId={checkinId} />
}
